import { Inject } from '@odinjs/odin';

import { Endpoint, ToastServiceProviderAccreditation } from '@philips-emr/hpms-provider-accreditation-commons';
import { FetchAPI, FieldAPI, PanelAPI } from '@philips-emr/tws-components';
import Controller, { OnAfterFetch, OnClick, OnClose, OnMount, OnSelect } from '@philips-emr/tws-core/lib/client';
import { FetchEvent, SelectEvent } from '@philips-emr/tws-core/lib/component/types';
import { FileService, msg } from '@philips-emr/tws-core/lib/services';
import { HttpMethod } from '@philips-emr/tws-core/lib/services/http-service';
import { isEmptyArrayOrObject, isEmptyObject } from '@philips-emr/tws-utils';

import BaseController from '../BaseController';

interface Attachment {
  dsFile: string;
  nrSeqAttachment: number;
}

interface Call {
  dtClose: string;
}

@Controller({ fragment: 'call-details' })
export default class CallDetailsController extends BaseController {

  @Inject('panel-modal')
  private panelModal: PanelAPI;
  @Inject('panel-history')
  private panelHistory: PanelAPI;
  @Inject('field-cancel-date')
  private fieldCancelDate: FieldAPI;
  @Inject('field-cancel-reason')
  private fieldCancelReason: FieldAPI;
  @Inject('field-attachments')
  private fieldAttachments: FieldAPI;

  @OnMount('fetch-call')
  onMountFetch(event: FetchEvent): void {
    const api = event.target as FetchAPI;
    const { nrSeqUser, nrSeqCall } = this.historyService.getCurrentRouteParams();
    this.context.set({ nrSeqUser });
    api.setParameters({ nrSeqCall, nrSeqUser });
    api.forceFetch();
  }

  @OnMount('fetch-history')
  onMountFetchHistory(event: FetchEvent): void {
    const api = event.target as FetchAPI;
    const { nrSeqUser, nrSeqCall } = this.historyService.getCurrentRouteParams();
    this.context.set({ nrSeqUser, nrSeqCall });
    api.setParameters({ nrSeqCall, nrSeqUser });
    api.forceFetch();
  }

  @OnMount('fetch-attachments')
  onMountFetchAttachments(event: FetchEvent): void {
    const api = event.target as FetchAPI;
    const { nrSeqUser, nrSeqCall } = this.historyService.getCurrentRouteParams();
    this.context.set({ nrSeqUser });
    api.setParameters({ nrSeqCall, nrSeqUser });
    api.forceFetch();
  }

  @OnAfterFetch('fetch-history')
  onAfterFetchHistory(event: FetchEvent): void {
    const data = event.data;

    if (!data) {
      this.panelHistory.setVisible(false);
    }
  }

  @OnAfterFetch('fetch-call')
  onAfterFetchCall(event: FetchEvent): void {

    const data = event.data as Call;
    const { dtClose } = data;
    if (isEmptyObject(dtClose)) {
      this.fieldCancelDate.setVisible(false);
      this.fieldCancelReason.setVisible(false);
    }

  }

  @OnAfterFetch('fetch-attachments')
  onAfterFetchAttachments(event: FetchEvent): void {
    const data = event.data as Attachment;
    if (isEmptyArrayOrObject(data)) {
      this.fieldAttachments.setVisible(false);
    }
  }

  @OnSelect('attachments-list')
  onSelectAttachment(event: SelectEvent<Attachment>): void {
    const { value } = event;
    const { nrSeqAttachment, dsFile } = value;
    const ieTable = 'calls';
    const { nrSeqUser } = this.historyService.getCurrentRouteParams();

    FileService.download(Endpoint.GET.CALL_ATTACHMENT_DOWNLOAD, dsFile,
      { ieTable, nrSeqAttachment, nrSeqUser }, HttpMethod.GET)
      .catch(() => ToastServiceProviderAccreditation.error(msg('pa.error-finding-file')));

  }

  @OnClick('hpms-custom-card-data')
  onClickShowMore(): void {
    this.panelModal.setVisible(true);
  }

  @OnClose('modal-history')
  onCloseModal(): void {
    this.panelModal.setVisible(false);
  }
}
